import React, { useEffect, useState } from 'react';

interface DataSendPerso {
    rpl_heure_reelle_depart_site: string;
    rpl_heure_consommee_en_plus: string;
    rpl_heure_a_facturer: string;
    v_heure_prevue_depart_site: string;
    e_uret_id: number | null;
    e_rpl_id: number;
}

const TimeInput: React.FC<{ name: any; value?: string; onChange: (value: string) => void; readOnly?: boolean; }> = ({ name, value, onChange, readOnly }) => {
    const [currentTime, setCurrentTime] = useState<string>('');

    // Fonction pour obtenir l'heure actuelle au format HH:mm
    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    // Mettre à jour l'heure actuelle au chargement du composant


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    return (
        <div className='namePersoContainer'>
            <p className='nameOfNumericInput'>{name}:</p>
            <input
                className='timeInput timerInput k-input-solid '
                type="time"
                value={value || currentTime}
                onChange={handleChange}
                step="60"
                readOnly={readOnly}
            />
        </div>
    );
};
export default TimeInput